'use client'

import { useEffect } from 'react'
import { Identity } from '@crystal-eyes/types'
import usePersistProfilePhoto from '@crystal-eyes/hooks/usePersistProfilePhoto'

export default function PhotoPersistHelper({
  identity,
}: {
  identity: Identity
}) {
  const { data: s3 } = usePersistProfilePhoto({ identity })
  useEffect(() => {
    s3.maybePersistPhoto()
  }, [s3])
  return null
}
